import React, { useEffect, useRef, useState } from "react";
import { capitalizeFirstLetter, cleanWhitespace, removeAllWhitespace, sanitizeNumberInput } from "../../../utils/helper";
import { CircularProgress } from "@mui/material";
import { DatePicker } from "antd";
import dayjs from "dayjs";
function PaymentForm({ onClose, AddPayment, loading ,isSelectedData}) {
  const [errors, setErrors] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showHourList, setShowHourList] = useState(false);
  const [showMinuteList, setShowMinuteList] = useState(false);
const [hourFilter, setHourFilter] = useState("");
const [hourIndex, setHourIndex] = useState(-1);

const [minuteFilter, setMinuteFilter] = useState("");
const [minuteIndex, setMinuteIndex] = useState(-1);
const hourOptions = [...Array(13)]
  .map((_, i) => String(i).padStart(2, "0"))
  .filter(h => h.includes(hourFilter));

const minuteOptions = [...Array(60)]
  .map((_, i) => String(i).padStart(2, "0"))
  .filter(m => m.includes(minuteFilter));


  const [formData, setFormData] = useState({
    paymentMode: "",    
    transactionID : "",   
    amount: "",
    notes: "",
     timeHour:"",
    timeMinute:"",
  timePeriod: "AM",
    transactionDateTime: dayjs().format("YYYY-MM-DD"),
  });
  const paymentModeRef = useRef(null); 

  const timeMinuteRef  = useRef(null);
  const timeHourRef  = useRef(null);
  const saveButtonRef = useRef(null); 
  const timePeriodRef  = useRef(null);
  
  const transactionID  = useRef(null);
  const amountRef = useRef(null);
  const notesRef = useRef(null);
  const transactionDateTime = useRef(null);

  const validate = () => {
    let tempErrors = {};
    let isValid = true;   
  
    const amount = Number(formData.amount);  
    const balance = Number(isSelectedData?.balanceAmount);    
    const totalAmount = Number(isSelectedData?.totalAmount);
    const thresholdPercent = 20;
    const twentyPercent = Math.ceil((totalAmount / 100) * thresholdPercent);
    const minRequiredAmount = balance < twentyPercent ? balance : twentyPercent;
 
    if (!formData.transactionDateTime) {
    tempErrors.transactionDateTime = "Date is required.";
    transactionDateTime.current?.focus();
    isValid = false;
  }
else if (!formData.timeHour) {
    tempErrors.transactionDateTime = "Hours is required."; 
    timeHourRef.current?.focus();
    isValid = false;
  }
   else if (formData.timeHour.length !== 2) {
    tempErrors.transactionDateTime = "Hours must be 2 digits."; 
    timeHourRef.current?.focus();
    isValid = false;
}
   else if (!formData.timeMinute) {
    tempErrors.transactionDateTime = "Minutes is required.";
    timeMinuteRef.current?.focus();
    isValid = false;
  }
  else if (formData.timeMinute.length !== 2) {
    tempErrors.transactionDateTime = "Minutes must be 2 digits.";
    timeMinuteRef.current?.focus();
    isValid = false;
}
 
  else  if (!formData.amount || amount <= 0) {        
        tempErrors.amount = "Amount must be greater than 0.";
        amountRef.current?.focus();
        isValid = false;
    }   
    else if (amount > balance) {       
        tempErrors.amount = `Amount cannot exceed the remaining balance of ${balance}.`;
        amountRef.current?.focus();
        isValid = false;
    }
    else if (amount < minRequiredAmount) {
        tempErrors.amount = `Minimum payment required is ₹${minRequiredAmount} .`;
        amountRef.current?.focus();
        isValid = false;
    }   
   else if (!formData.paymentMode) {
      tempErrors.paymentMode = "Payment is required.";
      paymentModeRef.current?.focus();
      isValid = false;
    }  
   else if (!formData.notes) {
      tempErrors.notes = "Notes are required.";
      notesRef.current?.focus();
      isValid = false;
    }
   else if (!formData.transactionID ) {
      tempErrors.transactionID  = "Transaction ID  is required.";
      transactionID.current?.focus();
      isValid = false;
    }   

    setErrors(tempErrors);
    return isValid;
  };

  const formatNameInput = (value) => { 
    let formattedValue = value.trimStart(); 
    formattedValue = formattedValue.replace(/\s+/g, ' ');     
    formattedValue = formattedValue.replace(/[^a-zA-Z\s]/g, '');

    return formattedValue;
  };

  const handleChange = (e) => {
    setErrors("");
    const { name, value } = e.target;
    let newValue = value;
    if (name === "name") {      
        newValue = formatNameInput(value);
    } else if (name === "notes" ) {
       newValue = cleanWhitespace(value);
    }
    else if (name === "transactionID") { 
      newValue = value.replace(/[^a-zA-Z0-9]/g, "");
    }else {       
        newValue = removeAllWhitespace(value); 
    }
    setFormData((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      AddPayment(formData);
    }
  };
 const handleAdd = (e) => {
    e.preventDefault();
    if (validate()) {
      setShowConfirm(true);
    }
  };
const handleEnterKey = (e, nextRef = null) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    const fieldName = e.target.name;
    const value = formData[fieldName];
    
    let currentErrors = {};
    let isFieldValid = true;

   if (!value) {
  let label = "";

  if (fieldName === "transactionID ") {
    label = " Transaction ID or UPI";
  } else {
    label = capitalizeFirstLetter(fieldName.replace(/([A-Z])/g, " $1"));
  }

  currentErrors[fieldName] = `${label} is required.`;
  isFieldValid = false;
}

    setErrors(currentErrors);
    if (!isFieldValid) return;
    if (nextRef && nextRef.current) {
        nextRef.current.focus();
    }   
    else if (e.target.tagName === "SELECT" && saveButtonRef.current) {
        saveButtonRef.current.focus();
    }    
    else if (e.target === saveButtonRef.current) {
        handleAdd(e);
    }
};

 useEffect(() => {     
        transactionDateTime.current.focus();
     
  }, []);

// const disabledFutureDates = (current) => {  
//   return current && current.isBefore(dayjs().startOf('day'), 'day');
// };
const disabledDate = (current) => {
  return current && current.isBefore(dayjs().subtract(90, "day").startOf("day"));
};
  return (
    <div>
      <div className="modal-backdrop show"></div>

      <div
        className="modal show d-block"
        id="ViewPartnerModal"
        tabIndex="-1"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content ">
            <div className="modal-header border-bottom-0 py-3">
              <h6 className="modal-title fw-semibold">Add Payment  </h6>
              <button
                type="button"
                className="btn-close border"
                onClick={onClose}
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body p-0">
              <form onSubmit={handleSubmit}>
                <div className="modal-body p-4">  
                    <div className="row mb-3">
                    
                        <label className="form-label">
                          Date & Time<span className="text-danger">*</span>
                        </label>
                         <div className="row mb-2">
                          <div className="col-md-4 p-1">
                       <div
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                if (formData.transactionDateTime) {
                                  timeHourRef.current?.focus();
                                }
                              }
                            }}
                          >
                          <DatePicker
                          ref={transactionDateTime}
                          value={formData.transactionDateTime ? dayjs(formData.transactionDateTime) : null}
                          onChange={(date) => {
                            setErrors({});
                            setFormData((prev) => ({
                              ...prev,
                              transactionDateTime: date ? date.format("YYYY-MM-DD") : ""
                            }));
                            amountRef.current?.focus();
                          }}
                          format="DD MMM YYYY"
                          disabledDate={disabledDate}
                          // disabledDate={(current) => current && current > dayjs().endOf("day")}
                          className="form-control p-0 custom-date ant-picker-0"       
                           getPopupContainer={() => document.body}                   
                          // onKeyDown={(e) => handleEnterKey(e, amountRef)}
                        />                         
                
                 </div>
               
                          {errors?.transactionDateTime && (
                            <div className="invalid-feedback d-block mt-1">
                              {errors.transactionDateTime}
                            </div>
                          )}
                        </div>      
    
                     <div className="col-3 p-1" style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="timeHour"
                          ref={timeHourRef}
                          className="form-control text-center"
                          placeholder="HH"
                          autoComplete="off"
                          value={formData.timeHour}
                          maxLength={2}
                          onFocus={() => {
                            setShowHourList(true);
                            setShowMinuteList(false);
                            setHourFilter("");
                          }}
                          onChange={(e) => {
                            const v = e.target.value.replace(/[^0-9]/g, "");
                            setHourFilter(v);
                            setErrors("");
                            setFormData((p) => ({ ...p, timeHour: v }));
                          }}
                        onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        setErrors("");
                          if (hourIndex >= 0) {
                            const selected = hourOptions[hourIndex];
                            setFormData((p) => ({ ...p, timeHour: selected }));
                            setShowHourList(false);
                            setHourIndex(-1);
                            timeMinuteRef.current?.focus();
                            return;
                          }
                          
                          if (hourOptions.length > 0) {
                            const first = hourOptions[0];
                            setFormData((p) => ({ ...p, timeHour: first }));
                            setShowHourList(false);
                            timeMinuteRef.current?.focus();
                            return;
                          }

                          setErrors({ timeHour: "Invalid hour" });
                          return;
                        }


                        if (e.key === "ArrowDown") {
                          e.preventDefault();
                          setHourIndex((prev) =>
                            prev < hourOptions.length - 1 ? prev + 1 : prev
                          );
                        }

                        if (e.key === "ArrowUp") {
                          e.preventDefault();
                          setHourIndex((prev) => (prev > 0 ? prev - 1 : 0));
                        }
                      }}

                        />

                        {showHourList && (
                          <div className="time-dropdown-box">
                            {hourOptions.map((hr, i) => (
                              <div
                                key={hr}
                                className={`time-dropdown-item ${
                                  hourIndex === i ? "bg-light fw-bold" : ""
                                }`}
                                onMouseDown={() => {
                                  setFormData((p) => ({ ...p, timeHour: hr }));
                                  setShowHourList(false);
                                  setErrors("");
                                  setHourIndex(-1);
                                  timeMinuteRef.current?.focus();
                                }}
                              >
                                {hr}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                                          
                        <div className="col-3 p-1" style={{ position: "relative" }}>
                        <input
                          type="text"
                          name="timeMinute"
                          ref={timeMinuteRef}
                          className="form-control text-center"
                          placeholder="MM"
                          autoComplete="off"
                          value={formData.timeMinute}
                          maxLength={2}
                          onFocus={() => {
                            setShowMinuteList(true);
                            setShowHourList(false);
                            setMinuteFilter("");
                          }}
                          onChange={(e) => {
                            const v = e.target.value.replace(/[^0-9]/g, "");
                            setMinuteFilter(v);
                            setErrors("");
                            setFormData((p) => ({ ...p, timeMinute: v }));
                          }}
                        onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          setErrors("");   
                          if (minuteIndex >= 0) {
                            const selected = minuteOptions[minuteIndex];
                            setFormData((p) => ({ ...p, timeMinute: selected }));
                            setShowMinuteList(false);
                            setMinuteIndex(-1);
                            timePeriodRef.current?.focus();
                            return;
                          }

                          if (minuteOptions.length > 0) {
                            const first = minuteOptions[0];
                            setFormData((p) => ({ ...p, timeMinute: first }));
                            setShowMinuteList(false);
                            timePeriodRef.current?.focus();
                            return;
                          }

                          setErrors({ timeMinute: "Invalid minute" });
                          return;
                        }

                        if (e.key === "ArrowDown") {
                          e.preventDefault();
                          setMinuteIndex((prev) =>
                            prev < minuteOptions.length - 1 ? prev + 1 : prev
                          );
                        }

                        if (e.key === "ArrowUp") {
                          e.preventDefault();
                          setMinuteIndex((prev) => (prev > 0 ? prev - 1 : 0));
                        }
                      }}

                        />

                        {showMinuteList && (
                          <div className="time-dropdown-box">
                            {minuteOptions.map((mm, i) => (
                              <div
                                key={mm}
                                className={`time-dropdown-item ${
                                  minuteIndex === i ? "bg-light fw-bold" : ""
                                }`}
                                onMouseDown={() => {
                                  setFormData((p) => ({ ...p, timeMinute: mm }));
                                  setShowMinuteList(false);
                                  setMinuteIndex(-1);
                                  setErrors("");
                                  timePeriodRef.current?.focus();
                                }}
                              >
                                {mm}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>




                        {/* <div className="col-2 p-1">
                        <input
                          type="text"
                          className="form-control text-center"
                          name="timeHour"
                          maxLength={2}
                          ref={timeHourRef}
                          placeholder="HH"
                          value={formData.timeHour}
                          onChange={(e) => {
                            const v = e.target.value.replace(/[^0-9]/g, "");
                            if (Number(v) <= 12) {
                              setFormData((p) => ({ ...p, timeHour: v }));
                               setErrors("");
                            }
                          }}
                          onKeyDown={(e) => handleEnterKey(e, timeMinuteRef)} 
                        />
                        </div> */}
                      {/* <div className="col-2 p-1">
                              <input
                                type="text"
                                className="form-control text-center"
                                name="timeMinute"
                                maxLength={2}
                                placeholder="MM"
                                ref={timeMinuteRef}
                                value={formData.timeMinute}
                                onChange={(e) => {
                                  const v = e.target.value.replace(/[^0-9]/g, "");
                                  if (Number(v) <= 59) {
                                    setFormData((p) => ({ ...p, timeMinute: v }));
                                     setErrors("");
                                  }
                                }}
                                 onKeyDown={(e) => handleEnterKey(e, timePeriodRef)} 
                              />
                            </div> */}
                        <div className="col-2 p-1">
                          <select
                            className="form-select"
                            name="timePeriod"
                            ref={timePeriodRef}
                            value={formData.timePeriod}
                            onChange={handleChange}
                             onKeyDown={(e) => handleEnterKey(e, amountRef)} 
                          >
                            <option value="AM">AM</option>
                            <option value="PM">PM</option>
                          </select>
                        </div>
                      </div>  
                         </div>             
                  <div className="row mb-3">
                     <div className="col-md-6 ">
                      <div className="">
                        <label className="form-label">
                          Amount  <span className="text-blue">(Remaining: ₹{isSelectedData?.balanceAmount || 0})</span> <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="amount"
                          name="amount"
                          autoComplete="off"
                          ref={amountRef}
                          value={formData.amount}
                          onKeyDown={(e) => handleEnterKey(e, paymentModeRef)} 
                          onChange={(e) => {
                            setErrors({});
                            const sanitizedValue = sanitizeNumberInput(
                              e.target.value
                            );
                            setFormData((prev) => ({
                              ...prev,
                              amount: sanitizedValue,
                            }));
                          }}
                          required
                          min="0"
                        />
                        {errors?.amount && (
                          <div className="invalid-feedback d-block mt-1">
                            {errors.amount}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 ">
                      <div className="">
                        <label className="form-label">
                          Payment Mode<span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-select"
                          id="paymentMode"
                          autoComplete="off"
                          name="paymentMode"
                          ref={paymentModeRef}
                          value={formData.paymentMode}
                          onChange={handleChange}
                          onKeyDown={(e) => handleEnterKey(e, notesRef)} 
                          required
                        >
                           <option value="">Select </option>                                
                          <option value="CASH">CASH</option>
                           <option value="CARD">CARD</option>        
                          <option value="UPI">UPI </option>
                           <option value="BANKTRANSFER">BANK TRANSFER</option>
                        </select>
                        {errors?.paymentMode && (
                          <div className="invalid-feedback d-block mt-1">
                            {errors.paymentMode}
                          </div>
                        )}
                      </div>
                    </div>{" "}                   
                  </div>                 
                  <div className="mb-3">
                    <label className="form-label">
                      Notes <span className="text-danger">*</span>
                    </label>

                    <textarea
                      className="form-control"
                      id="notes"
                      name="notes"
                      rows="3"
                      autoComplete="off"
                      ref={notesRef}                      
                      value={formData.notes}
                      onChange={handleChange}
                      onKeyDown={(e) => handleEnterKey(e, transactionID )}
                    ></textarea>
                    {errors?.notes && (
                      <div className="invalid-feedback d-block mt-1">
                        {errors.notes}
                      </div>
                    )}
                  </div>
                   <div className="row mb-3">
                    
                    <div className="col-md-12 ">
                      <label className="form-label">
                        Transaction ID <span className="text-danger">*</span>
                      </label>

                      <input
                        type="text"
                        className="form-control"
                        id="transactionID"
                        name="transactionID"
                        ref={transactionID}
                        autoComplete="off"
                        value={formData.transactionID}
                        onChange={handleChange}
                        onKeyDown={(e) => handleEnterKey(e, saveButtonRef)}                     
                      />
                      {errors?.transactionID  && (
                        <div className="invalid-feedback d-block mt-1">
                          {errors.transactionID }
                        </div>
                      )}
                    </div>                  
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button
                type="button"
                className="btn btn-outline-secondary px-3"
                onClick={onClose}
              >
                Close
              </button>
              <button
                type="button"
                ref={saveButtonRef}
                className="btn btn-primary px-3"
                 onClick={handleAdd}
                // disabled={loading.addPayment}
              > 
                    <i className="bx bx-plus"></i> Add
                
              </button>
            </div>
                      {showConfirm && (
                  <div className="modal-backdrop show"></div>
                )}
                {showConfirm && (
                  <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                      <div className="modal-content">
                        <div className="modal-header border-bottom-0 py-3">
                          <h6 className="modal-title">Confirm Payment</h6>
                          <button type="button" className="btn-close border" onClick={() => setShowConfirm(false)}></button>
                        </div>

                        <div className="modal-body">
                          <p className="fw-semibold">
                            Are you sure you want to add this payment of <span className="text-blue">₹{formData.amount}</span>?
                          </p>
                          <p className="mb-0">The remaining balance is <span className="text-danger">₹{isSelectedData?.balanceAmount -formData.amount}.</span></p>
                        </div>

                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setShowConfirm(false)}
                          >
                            No
                          </button>
{loading?.addPayment ?(
 <button
                                  className="btn btn-primary pb-0 text-right"
                                  disabled
                                >
                                  <CircularProgress
                                    size={22}
                                    className="text-white"
                                  />
                                </button>):(
                          <button
                            type="button"
                            className="btn btn-primary"
                            disabled={loading.addPayment}
                            onClick={handleSubmit}
                          >
                            Yes
                          </button>
                                )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
          </div>


        </div>
      </div>
    </div>
  );
}

export default PaymentForm;
